import { styled } from "styled-components";

export const PaymentFormContainer = styled.div`

    height:300px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const FormContainer = styled.form`

    height: 100px;
    min-width: 500px;

`;